import bigcommerceSparkDefaults from '../bigcommerce-spark/config.js';

export default {
  includes: ['bigcommerce-spark'],
  ...bigcommerceSparkDefaults,
  sortFields: [
    'relevance',
    'sort_order',
    'date_created:desc',
    'total_sold:desc',
    'name',
    'name:desc',
    'review_score:desc',
    'price',
    'price:desc',
  ],
  defaultView: 'productGrid',
  SearchRequestDefaults: {
    ...bigcommerceSparkDefaults.SearchRequestDefaults,
    pageSize: 12,
  },
  Widgets: [
    ...bigcommerceSparkDefaults.Widgets.filter(
      (w) =>
        !['SearchPage', 'SearchHeader', 'SearchBox', 'FitmentTableTabDesktop', 'FacetBrandTiles'].includes(
          w.name,
        ),
    ),
    {
      name: 'SearchPage',
      location: { selector: '#cm_results', class: 'animate-loaded animated' },
      template: 'SearchPage',
    },
    {
      name: 'SearchBox',
      location: '#quickSearch',
      template: 'SearchBox',
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
    },
    {
      name: 'FitmentTableTabDesktop',
      type: 'FitmentTable',
      location: 'a.tab-title[href="#tab-fitment"]',
      template: 'fitmentSearch/fitmentTableTabDesktop',
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm_brands',
      template: 'facetTiles/alphabeticalContainer',
      view: 'columns', // FIXME: 'grid' view not yet styled for the Spark theme
    },
  ],
};
